module.exports = __webpack_public_path__ + "static/media/b1.97b93661.jpg";